module.exports = __webpack_public_path__ + "img/HOUSE_BRAVERY.ebed1b69.svg";